import init from '../init.js';

export default function newsSection() {
	const news = document.getElementById('news');

	// Get out if we're not on the news page
	if (!news) return;

	const newsGrid = news.getElementsByClassName('news_group')[0];
	const showMore = e => {
		e.preventDefault();
		const loadMoreButton = news.getElementsByClassName('news_more')[0];
		loadMoreButton.classList.add('-loading');

		const page = loadMoreButton.getElementsByTagName('a')[0].getAttribute('href').split('/news/')[1];
		const request = new XMLHttpRequest();
		request.onload = _ => {
			loadMoreButton.remove();
			const contentPlaceholder = document.createElement('div');
			contentPlaceholder.innerHTML = request.response;
			const newButton = contentPlaceholder.getElementsByClassName('news_more')[0];
			const newCards = contentPlaceholder
				.getElementsByClassName('news_group')[0]
				.getElementsByClassName('cell');

			Array.from(newCards).forEach(card => {
				newsGrid.appendChild(card);
				init(card);
			});

			if (typeof newButton !== 'undefined') {
				news.appendChild(newButton);
				init(newButton);
				newButton.onclick = showMore;
			}

			contentPlaceholder.remove();
		}
		request.open('GET', `ajax/news/${page}`);
		request.send();
	};

	const loadMoreButton = news.getElementsByClassName('news_more')[0]
	if (typeof loadMoreButton !== 'undefined') loadMoreButton.onclick = showMore;
}



// WEBPACK FOOTER //
// ./source/scripts/sections/news.js